/**
 * Belgeleri sıralama işlemi
 * 
 * @param {Object} state - Uygulama state
 * @returns {Function} - Belgeleri sıralama fonksiyonu
 */
export const createSortDocumentsMethod = (state) => {
  /**
   * Belgeleri sırala
   * @param {Array} docs - Sıralanacak belge dizisi
   * @returns {Array} - Sıralanmış belge dizisi
   */
  return (docs) => {
    const { field, direction } = state.sortState.value;
    
    if (!field) return docs;
    
    return [...docs].sort((a, b) => {
      let valueA = a[field];
      let valueB = b[field];
      
      // Tarih alanları için özel işlem
      if (field === 'addDate') {
        valueA = new Date(valueA).getTime();
        valueB = new Date(valueB).getTime();
      }
      
      // String değerler için düzgün sıralama
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }
      
      // Null veya undefined değerleri en sona koy
      if (valueA === null || valueA === undefined) return 1;
      if (valueB === null || valueB === undefined) return -1;
      
      // Sıralama yönüne göre karşılaştır
      const directionLower = direction.toLowerCase();
      if (directionLower === 'asc') {
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      } else {
        return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
      }
    });
  };
};